import myLoansModal from './myLoansModal/myLoansModal';
import modalDetailLoan from './modalDetailLoan/modalDetailLoan';
import myLoansRequestCadastral from './myLoansRequestCadastral/myLoansRequestCadastral';
import modalCadastralReference from './modalCadastralReference/modalCadastralReference';
import modalDetailAdhesionComponent from './modalDetailAdhesion/modalDetailAdhesion';

let myLoansModalsModule = angular.module('myloans.components.modals', [
  modalCadastralReference,
  myLoansModal,
  modalDetailLoan,
  myLoansRequestCadastral,
  modalDetailAdhesionComponent,
])

.name;

export default myLoansModalsModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/modals.js